// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2ts4u","title":"InfoRow_title__1MVGl"};